import { FC, useCallback } from 'react';
import { useExperimentFlag } from '../../../utils/useExperimentFlag';
import { useTranslation } from '../../../utils/useTranslation';
import { IconArrowDiagonalRight } from '../../icon/IconArrowDiagonalRight';
import { IconPurchases16 } from '../../icon/IconPurchases16';
import { Button } from '../../input/Button';
import { PostProductTargetLinkProps } from './typings';

export const PostProductTargetLink: FC<PostProductTargetLinkProps> = ({
    checkout,
    onCheckoutAnalytics,
    ...other
}) => {
    const t = useTranslation();
    const checkoutFlagValue = Number(useExperimentFlag('products_checkout'));
    const withCheckout = (checkoutFlagValue === 1 || checkoutFlagValue === 2) && checkout?.url;

    const onCheckoutClick = useCallback(
        (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            e.preventDefault();

            onCheckoutAnalytics?.();
            checkout?.url && window.open(checkout?.url, '_blank');

            return;
        },
        [checkout?.url, onCheckoutAnalytics],
    );

    if (withCheckout) {
        return (
            <Button as="a" onClick={onCheckoutClick} color="searchRed" size="m" {...other}>
                <IconPurchases16 size={16} margin="0 8px 0 0" />
                {t('Купить')}
            </Button>
        );
    }

    return (
        <Button color="secondary" size="m" {...other}>
            {t('На сайт')}
            <IconArrowDiagonalRight size={16} margin="0 0 0 8px" />
        </Button>
    );
};
